import { SYSState } from "../../../../_ovlclient/src"
import {
  AppDefProcess,
  SYSConfigType,
  versionInfo,
} from "../../../../_ovlclient/src/config"

export { appActions } from "./appactions"
export { appState } from "./appstate"

export const app = {
  permissions: { TR: {}, AU: {} },
  features: {
    SYSTableSettingsSaveFilterSortAll: {},
    SYSTableSettingsSaveFilterSortCompany: {},
    SYSTableSettingsSaveFilterSortOwn: {},
    SYSTableSettingsReadOnlyFilterSort: {},
  },
  longRunningProcess: {
    NewServiceSnackGetSlots: <AppDefProcess>{
      snack: { type: "BusyIndicator" },
    },
  },
  editors: {},
  dialogs: {},
  forms: {
    SVLNewServiceStep1: {},
    SVLNewServiceStep2: {},
    SVLNewServiceStep3: {},
  },
  tableDefIds: {},
  languages: { DE: {} },
  screens: {
    SVLNewServiceStep1: {},
    SVLNewServiceStep2: {},
    SVLNewServiceStep3: {},
  },
  customValidators: {},
}

export let SYSConfig: SYSConfigType = {
  _system: {
    debugTracking: false,
    versionInfo,
    isDev: false,
    showSaveOrigin: true,
    statePersistVersion: 1,
    defaultDateTimeControlSubmitType: "UTC",
    suppressAfterRenderIfGetUIEmpty: true,

    appId: "001",
  },
  app,
  formDefaults: {
    showErrorWhileTyping: false,
  },
  init: {
    initalScreen: "SVLNewServiceStep1",
  },
  fetch: {
    timeout: 5000,
  },
  global: {
    defaultDialogTitle: "NewServiceDialogTitle",
    stickyHeaderEnabled: (state: SYSState) => true,
  },
}
